webpackJsonp([241163179445735],{

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreExtractAction = __webpack_require__(54);
	
	var _LoreExtractAction2 = _interopRequireDefault(_LoreExtractAction);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreExtractAction2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'create'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'CLI command to extract the ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/actions/create/' },
	        'create action'
	      ),
	      ' for a given model into your project.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      lore extract action [model]/create\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Example'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      lore extract action post/create\n      ' }),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import { ActionTypes, PayloadStates, payload, normalize } from \'lore-utils\';\n\n      /*\n       * Blueprint for Create method\n       */\n      export default function create(params) {\n        return function(dispatch) {\n          const Model = lore.models.post;\n          const model = new Model(params);\n\n          model.save().then(function() {\n            // look through the model and generate actions for any attributes with\n            // nested data that should be normalized\n            const actions = normalize(lore, \'post\').model(model);\n\n            dispatch({\n              type: ActionTypes.update(\'post\'),\n              payload: payload(model, PayloadStates.RESOLVED)\n            });\n\n            // dispatch any actions created from normalizing nested data\n            actions.forEach(dispatch);\n          }).catch(function(response) {\n            const error = response.data;\n\n            dispatch({\n              type: ActionTypes.remove(\'post\'),\n              payload: payload(model, PayloadStates.ERROR_CREATING, error)\n            });\n          });\n\n          return dispatch({\n            type: ActionTypes.add(\'post\'),\n            payload: payload(model, PayloadStates.CREATING)\n          });\n        };\n      };\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cli-lore-extract-action-actions-create-js-728812ab1f147949d71f.js